module.exports = __webpack_public_path__ + "static/media/icon-nav-dashboard-on.e893058b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-nav-dashboard-on.svg
// module id = 1214
// module chunks = 19